import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";

// Signal that the app has mounted successfully
// This prevents the SEO fallback shell from showing
(window as any).__appMounted = true;
if ((window as any).__seoFallbackTimer) {
  clearTimeout((window as any).__seoFallbackTimer);
}

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
